export { default } from "-!./script.js?vue&type=script&lang=js&external"; export * from "-!./script.js?vue&type=script&lang=js&external"